import React from 'react'
import {
    Box,
    Button,
    Divider,
    Flex,
    FormControl,
    FormLabel,
    Input,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    Select,
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    useToast,

} from '@chakra-ui/react'
import { useFormik } from "formik";
import axios from 'axios'
import { Auth } from './Auth';
import { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { MdOutlineChevronRight } from "react-icons/md";
import { BiArrowBack } from 'react-icons/bi';
import { Context } from './store';
// import { RxCounterClockwiseClock } from 'react-icons/rx';


// import * as Yup from "yup";

// search formik value
const searchValues = {
    shopifyOrderName: '',
    shopifyOrderId: '',
    invoiceId: '',
    orderSatusId: '',
    productId: '',
    tenureId: '',
    customerPartyId: '',
    tenureStatusId: '',
    tenurePeriodId: '',
    draftOrderId: '',
    webhookProcessed: '',
    customerPhoneNumber: '',
    customerEmailId: '',
    orderGstNumber: ''
}

// // search Yup Validation schema
// const searchSchema = Yup.object({
//     shopifyOrderName: Yup.string(),
//     shopifyOrderId: Yup.string(),

//   });

const OrderSearchModal = ({ onClose, create }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [searchResult, setSearchResult] = useState({status: 'Failure', error: false, isSearched: false})
    const [searchData, setSearchData] = useState([])
    // const [deliveryBoyPartyId, setDeliveryBoyPartyId] = useState([])
    const toast = useToast()
 
    const { userData } = useContext(Context)
    const user = userData
    const { values,  handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: searchValues,
    //   validationSchema: searchSchema,
      onSubmit: (values, action) => {
        setIsLoading(true)
        // API CALL FOR ORDER SEARCH
        let data = JSON.stringify({
        "invoiceId": `${values.invoiceId}`,
        "orderName": `${values.shopifyOrderName}`,
        "shopifyOrderId": `${values.shopifyOrderId}`,
        "orderSatusId": `${values.orderSatusId}`,
        "productId": `${values.productId}`,
        "customerPartyId": `${values.customerPartyId}`,
        "tenureId": `${values.tenureId}`,
        "tenureStatusId": `${values.tenureStatusId}`,
        "draftOrderId" : `${values.draftOrderId}`,
        "webhookProcessed" : values.webhookProcessed === "true" ? true : values.webhookProcessed === "false" ? false :  "",
        "customerPhoneNumber" : `${values.customerPhoneNumber}`,
        "customerEmailId" : `${values.customerEmailId}`,
        "orderGstNumber" : `${values.orderGstNumber}`
        });

        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/context/search`,
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': Auth()

        },
        data : data
        };

        axios.request(config)
        .then((response) => {
            console.log(response, '###########')
            if(response.data.length > 0){
                // ###### GET DELIVERY BOY DETAILS ######
                let config101 = {
                  method: 'get',
                  maxBodyLength: Infinity,
                  url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/party/member?orderId=${response.data[0]?.id}&orderItemSeqId=${response.data[0]?.OrderItem[0].orderItemSeqId}`,
                  headers: {
                      'Authorization': Auth()
                   }
              };
              
              axios.request(config101)
              .then((res) => {
                //   setDeliveryBoyPartyId(res.data);
                  if(response.data.length === 0){
                      toast({
                          title: 'Your search did not match with any order detials',
                          status: 'error',
                          duration: 4000,
                          position: 'bottom',
                          isClosable: true,
                        })
                  }else {
                      if(response.data.length > 0 && (user.UserGroupPermission.includes('ORDER_MANAGEMENT') || user.userGroupMember.includes("ADMIN"))){
                          setSearchData(response.data);
                          setSearchResult({status: 'Success', error: false, isSearched: true})
                          setIsLoading(false)
                      }else {
                          if(res.data[0]?.partyId ===  user.partyId){
                              setSearchData(response.data);
                              setSearchResult({status: 'Success', error: false, isSearched: true})
                              setIsLoading(false)
                          }else{
                              setSearchResult({status: 'Success', error: false, isSearched: false})
                              toast({
                                  title: 'Your search did not match with any order detials',
                                  status: 'error',
                                  duration: 4000,
                                  position: 'bottom',
                                  isClosable: true,
                                })
                                setIsLoading(false)
                          }
                      }
                  }
                  
              })
              .catch((error) => {
                  console.log(error);
                  setIsLoading(false)
                  setSearchResult({status: 'Failure', error: true, isSearched: false})
                  toast({
                      title: 'Oops we are facing some temporary issue with your request',
                      status: 'error',
                      duration: 3000,
                      position: 'bottom',
                      isClosable: true,
                    })
              });
            }else {
                toast({
                    title: 'Your search did not match with any order detials',
                    status: 'error',
                    duration: 4000,
                    position: 'bottom',
                    isClosable: true,
                  })
                  setIsLoading(false)
            }

        })

        .catch((error) => {
        console.log(error);
        setIsLoading(false)
        setSearchResult({status: 'Failure', error: true, isSearched: false})
        toast({
            title: 'Oops we are facing some temporary issue with your request',
            status: 'error',
            duration: 3000,
            position: 'bottom',
            isClosable: true,
          })
        });

      
        
        action.resetForm()
      },
    });


      // status str format
      const convertStatus = (str) =>  {
        // Split the string by underscores
        var words = str.split('_');
      
        // Capitalize the first letter of each word
        for (var i = 0; i < words.length; i++) {
          words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
        }
      
        // Join the words with a space
        var result = words.join(' ');
      
        return result;
      }
      
   
  return (
    <ModalContent>
    <ModalHeader textAlign={'center'}>
    <Flex w={'full'}>
        <Box flexBasis={'3%'}>
        {searchResult.isSearched &&
            <BiArrowBack onClick={() => {
                setSearchResult({status: 'Failure', error: false, isSearched: false})
                setSearchData([])
                // setDeliveryBoyPartyId([])
            }} fontSize={'32px'} style={{cursor: "pointer"}}/>
        }
        </Box>
        <Box flexBasis={'97%'}>
            Search Order
        </Box>

    </Flex>
    </ModalHeader>
    <Divider/>
    <ModalCloseButton mt={'7.5px'} />
    <ModalBody pb={6}>
    {searchResult.isSearched ?
                 // ##### SEARCHED RESULT #####
                <TableContainer height={`${window.innerHeight - 244}px`} overflowY={'scroll'}>
                    <Table variant={'simple'} size={'xs'}>
                        <Thead bgColor={'gray.100'} position={'sticky'} top={'0px'} zIndex={'99'}>
                            <Tr bgColor={'#E2DFDF'}>
                            <Th fontSize={{base: 'xs', md: 'xs', lg: 'xs', xl: 'xs', '2xl': 'sm'}} py={3} _first={{paddingLeft: '20px'}} color={'#25282B'}>{"Order"}</Th>
                            <Th fontSize={{base: 'xs', md: 'xs', lg: 'xs', xl: 'xs', '2xl': 'sm'}} py={3} _first={{paddingLeft: '20px'}} color={'#25282B'}>{"Date"}</Th>
                            {/* <Th fontSize={{base: 'xs', md: 'xs', lg: 'xs', xl: 'xs', '2xl': 'sm'}} py={3} _first={{paddingLeft: '20px'}} color={'#25282B'}>{"Customer Name"}</Th> */}
                            <Th fontSize={{base: 'xs', md: 'xs', lg: 'xs', xl: 'xs', '2xl': 'sm'}} py={3} _first={{paddingLeft: '20px'}} color={'#25282B'}>{"Total"}</Th>
                            <Th fontSize={{base: 'xs', md: 'xs', lg: 'xs', xl: 'xs', '2xl': 'sm'}} py={3} _first={{paddingLeft: '20px'}} color={'#25282B'}>{"Items"}</Th>
                            <Th fontSize={{base: 'xs', md: 'xs', lg: 'xs', xl: 'xs', '2xl': 'sm'}} py={3} _first={{paddingLeft: '20px'}} color={'#25282B'}>{"Order Status"}</Th>
                            <Th fontSize={{base: 'xs', md: 'xs', lg: 'xs', xl: 'xs', '2xl': 'sm'}} py={3} _first={{paddingLeft: '20px'}} color={'#25282B'}>{"Action"}</Th>
                            <Th fontSize={{base: 'xs', md: 'xs', lg: 'xs', xl: 'xs', '2xl': 'sm'}} py={3} _first={{paddingLeft: '20px'}} color={'#25282B'}>{""}</Th>
                              
                            </Tr>
                        </Thead>
                        <Tbody >
                            {searchData.map((d, i) => (
                                
                                <Tr key={i}  bgColor={'white'}>
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3} pl={5}>{d?.OrderName.includes('#') ? d?.OrderName : 'Draft'}</Td>
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3}>{
                                        new Intl.DateTimeFormat('en-US', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric',
                                            hour: 'numeric',
                                            minute: 'numeric',
                                            hour12: true,
                                            timeZone: 'ASIA/KOLKATA'
                                          }).format(new Date(d.placedDate))
                                    }</Td>
                                    {/* <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3}>{`${d?.customerParty?.firstName} ${d?.customerParty?.lastName}`}</Td> */}
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3}>{"Rs." + Number(d?.grandTotal).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    }) || "----"}</Td>
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3} pl={4} >{d.OrderItem.length}</Td>    
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3} pl={4}>
                                        <Button size={'xs'} cursor={'default'} colorScheme={(d?.orderStatusId === 'ORDER_CREATED' && 'green') ||
                                        (d?.orderStatusId === 'ORDER_PUBLISHED' && 'facebook') || 
                                        (d?.orderStatusId === 'ORDER_DRAFT' && 'purple') || 
                                        (d?.orderStatusId === 'ORDER_VERIFIED' && 'whatsapp') || 
                                        (d?.orderStatusId === 'ORDER_DELIVERED' && 'yellow') || 
                                        (d?.orderStatusId === 'ORDER_CANCELED' && 'red') || 
                                        (d?.orderStatusId === 'ORDER_OUT_FOR_DELIVERY' && 'orange') || 
                                        (d?.orderStatusId === 'ORDER_TRANSIT' && 'messenger') || 
                                        (d?.orderStatusId === 'ORDER_RETURNED' && 'telegram') || 
                                        (d?.orderStatusId === 'ORDER_PENDING_FOR_FULFILLMENT' && 'teal') || 
                                        (d?.orderStatusId === 'ORDER_READY_FOR_FULFILLMENT' && 'linkedin') || 
                                        (d?.orderStatusId === 'ORDER_PICKED' && 'pink') ||
                                        (d?.orderStatusId === 'AWAITING_VERIFICATION' && 'cyan')
                                        }>
                                                {convertStatus(d.orderStatusId).split(' ').filter((d) => d !== "Order").join(' ')}
                                    </Button>
                                    </Td>
                                   
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}} py={3} >
                                    {(d?.orderStatusId === 'AWAITING_VERIFICATION' && create === 'Order') ?
                                    <>
                                   
                                        <Link to={`/verification/customer-verification-details/${d?.id}`}>
                                            <Button size={'xs'}  bgColor={'#8BC34A'}  color={'white'} _hover={{bgColor:'#8BC34A', opacity: '0.9'}} rounded={'full'}>Move to Verified</Button>
                                        </Link>
                                    
                                    </>
                                    :
                                    null
                                    }
                                    </Td>
                                    <Td fontSize={{base: 'xs', md: 'sm', lg: 'sm', xl: 'sm', '2xl': 'sm'}}>
                                        <Flex>
                                         <Box bgColor={'gray.200'} rounded={'full'} my="auto" p={2} mx={2}>
                                    {create === 'Delivery Boy' && 
                                        <Link to={`/order-delivery/details/${d?.id}`}>
                                            <MdOutlineChevronRight />
                                        </Link>
                                    }
                                    {create === 'Order' && 
                                        <Link to={`/orders/order/${d?.id}`}>
                                            <MdOutlineChevronRight />
                                        </Link>
                                    }
                                            </Box>
                                        </Flex>
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>        
                    </Table>
                </TableContainer>
    :
    <>
    {/* ##### SEARCH FIELDS #### */}
     <Flex justifyContent={'space-between'}>
            <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>Shopify Order Name</FormLabel>
                <Input placeholder='Enter shopify order name' name='shopifyOrderName' value={values.shopifyOrderName} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>

            <FormControl mt={4} flexBasis={'47%'} >
                <FormLabel>Shopify Order Id</FormLabel>
                <Input placeholder='Enter shopify order Id' name='shopifyOrderId' value={values.shopifyOrderId} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>
        </Flex>

        <Flex justifyContent={'space-between'}>
            <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>Invoice Id</FormLabel>
                <Input placeholder='Enter Invoice Id' name='invoiceId' value={values.invoiceId} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>

            <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>Tenure Period Id</FormLabel>
                <Input placeholder='Enter tenure period id' name='tenurePeriodId' value={values.tenurePeriodId} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
             </FormControl>
        </Flex>

        <Flex justifyContent={'space-between'}>
            <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>Product Id</FormLabel>
                <Input placeholder='Enter product id' name='productId' value={values.productId} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>
        
            <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>Customer Party Id</FormLabel>
                <Input placeholder='Enter customer party id' name='customerPartyId' value={values.customerPartyId} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>
        </Flex>
        <Flex justifyContent={'space-between'}>
            <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>Tenure Id</FormLabel>
                <Input placeholder='Enter tenure id' name='tenureId' value={values.tenureId} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>

            <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>Tenure Status Id</FormLabel>
                <Input placeholder='Enter tenure status id' name='tenureStatusId' value={values.tenureStatusId} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>
        </Flex>

        <Flex justifyContent={'space-between'}>
            <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>Order Status Id</FormLabel>
                <Input placeholder='Enter order status id' name='orderSatusId' value={values.orderSatusId} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>

            <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>Draft Order Id</FormLabel>
                <Input placeholder='Enter draft order id' name='draftOrderId' value={values.draftOrderId} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>
        </Flex>

        <Flex justifyContent={'space-between'}>
            <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>Webhook Processed</FormLabel>
                <Select placeholder='Select option' name={'webhookProcessed'} onChange={handleChange} onBlur={handleBlur}>
                    <option value='true'>True</option>
                    <option value='false'>False</option>
                </Select>
            </FormControl>

            <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>Customer Phone Number</FormLabel>
                <Input  placeholder='Enter Customer Phone Number' name='customerPhoneNumber' value={values.customerPhoneNumber} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>
        </Flex>

        <Flex justifyContent={'space-between'}>
            <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>Customer Email Id</FormLabel>
                <Input placeholder='Enter Customer Email Id' name='customerEmailId' value={values.customerEmailId} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>

            <FormControl mt={4} flexBasis={'47%'}>
                <FormLabel>Order GST Number</FormLabel>
                <Input placeholder='Enter Order GST Number' name='orderGstNumber' value={values.orderGstNumber} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            </FormControl>
        </Flex>
        {/* <FormControl mt={4}>
            <FormLabel>Tenure Period Id</FormLabel>
            <Input placeholder='Enter tenure period id' name='tenurePeriodId' value={values.tenurePeriodId} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
        </FormControl> */}
        </>
     }



        
    </ModalBody>

    <ModalFooter w={'full'}>
         {/* <Button  mr={3} onClick={onClose} width={'50%'}>Cancel</Button> */}
         <Button colorScheme='green' onClick={handleSubmit} width={'100%'} isLoading={isLoading}
         isDisabled={!(
            values.customerPartyId.length > 0 || values.shopifyOrderName.length > 0 || values.shopifyOrderId.length > 0 || values.invoiceId.length > 0
            || values.tenurePeriodId.length > 0 || values.productId.length > 0 || values.tenureId.length > 0 || values.tenureStatusId.length > 0 || 

            values.orderSatusId.length > 0 || values.draftOrderId.length > 0 || values.webhookProcessed.length > 0 || values.customerPhoneNumber.length > 0
            || values.customerEmailId.length > 0 || values.orderGstNumber.length > 0   )
         }
         >
             Search
         </Button>
    </ModalFooter>
</ModalContent>
  )
}

export default OrderSearchModal